import { Injectable, EventEmitter } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { NotificationTypes } from "src/app/core/models/NotificationTypes";
import { TranslateService } from "@ngx-translate/core";
import * as moment from "moment";

@Injectable({
  providedIn: "root"
})
export class NotificationsService {
  updateNotifications = new EventEmitter<any>();

  constructor(
    private httpClient: HttpClient,
    private translateService: TranslateService
  ) { }

  getNotifications(page: number, limit: number) {
    return this.httpClient.get<{ items: any[], count: number }>(`${environment.serverPath}/general/notifications?limit=${limit}&page=${page}`);
  }

  getNotificationText(data: any) {
    if(! ('notificationType' in data)){return};
    if (data.notificationType === NotificationTypes.NewPost) {
      const text = data.sender ? data.sender : data.profile;
      return this.translateService.instant("headerPage.NewPostFrom", text);
    } else if (data.notificationType === NotificationTypes.Friends) {
      return this.translateService.instant("YouAreNowFriendsWith", data.notificationData.otherProfile);
    } else if (data.notificationType === NotificationTypes.FriendsRequest) {
      return this.translateService.instant("YouHaveAFriendRequestFrom", data.notificationData.otherProfile);
    } else if (data.notificationType === NotificationTypes.Like) {
      return this.translateService.instant("YouHaveNewLikeFrom", data.profile);
    } else if (data.notificationType === NotificationTypes.Comment) {
      return this.translateService.instant("YouHaveNewCommentFrom", data.profile);
    } else if(data.notificationType === NotificationTypes.eventInvitation) {
      return this.translateService.instant("YouHaveNewInvitationFromToEvent",  {profile:data.profile, eventName: data.notificationData.name});
    } else if (data.notificationType === NotificationTypes.communityInvitation) {
      return this.translateService.instant("YouHaveNewInvitationFromToCommunity", {profile:data.profile, communityName: data.notificationData.name});
    } else if(data.notificationType === NotificationTypes.eventInvitationAccepted ) {
      return this.translateService.instant("UserAcceptedInvitationToEvent", {profile:data.profile, eventName: data.notificationData.name});
    } else if(data.notificationType === NotificationTypes.communityInvitationAccepted) {
      return this.translateService.instant("UserAcceptedInvitationToCommunity", {profile:data.profile, communityName: data.notificationData.name});
    } else if(data.notificationType === NotificationTypes.upComingEventDay) {
      if(!this.isValidDate(data.notificationData.eventDate)) {
        data.notificationData.eventDate = data.notificationData.eventDate 
      }
      else {
        if (typeof data.notificationData.eventDate === "string") {
  
          // Check if the date is in ISO format
          const isISO = moment(data.notificationData.eventDate, moment.ISO_8601, true).isValid();
  
          if (!isISO) {
            // Convert to DD/MM/YYYY HH:mm if not ISO

          } else {
            data.notificationData.eventDate = moment(
              data.notificationData.eventDate,
              moment.ISO_8601,
            ).format("DD/MM/YYYY HH:mm");
          }
  
        } else {
          // data.notificationData.eventDate = moment(data.notificationData.eventDate).format("DD/MM/YYYY HH:mm");
        }
    }
      return this.translateService.instant("upcomingEventInDay", data.notificationData);
    } else if(data.notificationType === NotificationTypes.upComingEventHour) {
      if(!this.isValidDate(data.notificationData.eventDate)) {
        data.notificationData.eventDate = data.notificationData.eventDate 
      }
      else {
        data.notificationData.eventDate = moment(data.notificationData.eventDate).format("HH:mm");
      }
      return this.translateService.instant("upcomingEventInHour", data.notificationData);
    } else if(data.notificationType === NotificationTypes.upComingEventNow) {
      if(!this.isValidDate(data.notificationData.eventDate)) {
        data.notificationData.eventDate = data.notificationData.eventDate 
      }
      else {
        data.notificationData.eventDate = moment(data.notificationData.eventDate).format("HH:mm");
      }
      return this.translateService.instant("upcomingEventNow", data.notificationData);
    } else if(data.notificationType === NotificationTypes.eventDateUpdated) {
      if(!this.isValidDate(data.notificationData.eventDate)) {
        data.notificationData.eventDate = data.notificationData.eventDate 
      }
      else {

      data.notificationData.eventDate = moment(data.notificationData.eventDate).format("DD/MM/YYYY HH:mm");}
      return this.translateService.instant("eventDateUpdated", data.notificationData);
    }
  }
  isValidDate(date: any): boolean {
    const parsedDate = new Date(date);
    return !isNaN(parsedDate.getTime()); // Returns true if the date is valid
  }
  markAllAsRead() {
    return this.httpClient.post(`${environment.serverPath}/general/notifications/mark-all-read`, {});
  }

  markNotificationRead(notificationId: number) {
    return this.httpClient.post(`${environment.serverPath}/general/notifications/read/${notificationId}`, {});
  }
  deleteNotification(notificationId: number) {
    return this.httpClient.delete(`${environment.serverPath}/general/notifications/${notificationId}`);
  }
}
